module.exports = __webpack_public_path__ + "img/pencil.2855e328.svg";